import { implementCustomExpressions, implementCustomInvariants } from '../__generated/implementation.js';
import { horizontalHoleCountOptions, verticalHoleCountOptions } from '../data/plate-data.js';
import { getFixingHoleCountUpdate } from './kick-plate-fixing-holes.js';
export const kickPlateBulkOrderItemExpressions = implementCustomExpressions({
    KickPlateBulkOrderItem: {
        $horizontalLengthMin: (s)=>s.$plate.$minHorizontalLength,
        $horizontalLengthMax: (s)=>s.$plate.$maxRawSize.x,
        $verticalLengthMin: (s)=>s.$plate.$minVerticalLength,
        $verticalLengthMax: (s)=>s.$plate.$maxRawSize.y,
        $horizontalHoleCount: (s)=>{
            if (s.horizontalHoleCount < 0) {
                return getFixingHoleCountUpdate(s.$plate.$sizeX);
            }
            return s.horizontalHoleCount;
        },
        $verticalHoleCount: (s)=>{
            if (s.verticalHoleCount < 0) {
                return getFixingHoleCountUpdate(s.$plate.$sizeY);
            }
            return s.verticalHoleCount;
        },
        $availableHorizontalHoleCountOptions: ()=>horizontalHoleCountOptions,
        $availableVerticalHoleCountOptions: ()=>verticalHoleCountOptions
    }
});
export const kickPlateBulkOrderItemInvariants = implementCustomInvariants({
    KickPlateBulkOrderItem: {
        kickPlateFixingHolesMissing: (s)=>{
            return s.$horizontalHoleCount > 0 || s.$verticalHoleCount > 0;
        }
    }
});

//# sourceMappingURL=kick-plate-bulk-order-item.js.map